// these are the values that match the back-end implementation
export enum MessageMedium {
  Email = 'Email',
  InApp = 'InApp',
  SMS = 'SMS',
  Push = 'Push',
  WebPush = 'WebPush',
}

// Keeping EmbeddedMessageMedium separate since it is a paid feature behind the EmbeddedMessagingCore FF
// and we don't want it to automatically be pulled into places we may iterate over the MessageMedium enum
export enum EmbeddedMessageMedium {
  Embedded = 'Embedded',
}
// typed embedded value to be used explicitly as a MessageMedium value
export const EmbeddedMessage = EmbeddedMessageMedium.Embedded as unknown as MessageMedium;

export enum WhatsAppMedium {
  WhatsApp = 'WhatsApp',
}

export const WhatsApp = WhatsAppMedium.WhatsApp as unknown as MessageMedium;

export const { WhatsApp: WHATS_APP } = WhatsAppMedium;
// typed embedded value, currently used in journeys
export const { Embedded: EMBEDDED } = EmbeddedMessageMedium;

export const { Email: EMAIL, InApp: IN_APP, SMS, Push: PUSH, WebPush: WEB_PUSH } = MessageMedium;

const { Email, InApp, Push, WebPush } = MessageMedium;

export const MESSAGE_MEDIUMS = {
  EMAIL: {
    adjective: 'email',
    dbKey: EMAIL,
    label: 'Email',
    messageType: Email,
    messageTypeId: 1,
  },
  IN_APP: {
    adjective: 'in-app',
    dbKey: IN_APP,
    label: 'In-App',
    messageType: InApp,
    messageTypeId: 2,
  },
  SMS: {
    adjective: 'SMS',
    dbKey: SMS,
    label: 'SMS',
    messageType: SMS,
    messageTypeId: 3,
  },
  PUSH: {
    adjective: 'push',
    dbKey: PUSH,
    label: 'Push',
    messageType: Push,
    messageTypeId: 4,
  },
  WEB_PUSH: {
    adjective: 'web push',
    dbKey: WEB_PUSH,
    label: 'Web Push',
    messageType: WebPush,
    messageTypeId: 5,
  },
};

export const MESSAGE_MEDIUMS_WITH_EMBEDDED = {
  ...MESSAGE_MEDIUMS,
  [EmbeddedMessageMedium.Embedded]: {
    adjective: 'embedded',
    dbKey: EmbeddedMessage,
    label: 'Embedded',
    messageType: EmbeddedMessage,
    messageTypeId: 6,
  },
};

export const MESSAGE_MEDIUM_WHATS_APP = {
  [WhatsAppMedium.WhatsApp]: {
    adjective: 'WhatsApp',
    dbKey: WhatsApp,
    label: 'WhatsApp',
    messageType: WhatsApp,
    messageTypeId: 7,
  },
};

export const MESSAGE_MEDIUMS_WITH_WHATS_APP = {
  ...MESSAGE_MEDIUMS,
  ...MESSAGE_MEDIUM_WHATS_APP,
};

export const MESSAGE_MEDIUMS_WITH_DESTINATION = [
  MessageMedium.InApp,
  MessageMedium.Push,
  // Disabled until destinations are supported
  // EmbeddedMessage,
];
